export default "__VITE_ASSET__uL6F8QPf__"